import { Model, modelRegistry } from './Model';
import { Product, ProductCategory } from '.';
export class Button extends Model {
    static entity = 'buttons';
    id = null;
    background_color = '#FFFFFF';
    type = null;
    group_id = null;
    category_id = null;
    product_id = null;
    row_num = 1;
    column_num = 1;
    image = null;
    image_url = null;
    image_fit = 0;
    image_halign = 'center';
    image_stretch = 1;
    image_valign = 'center';
    text = '';
    text_halign = 'center';
    text_size = '12px';
    text_valign = 'center';
    /** Rendering model: 1 = legacy (saved appearance, verbatim), 2 = design tone tile. */
    version = 1;
    created_at = null;
    updated_at = null;
    category;
    product;
    static fields() {
        return {
            id: this.attr(null),
            background_color: this.attr('#FFFFFF'),
            type: this.attr(null),
            group_id: this.attr(null),
            category_id: this.attr(null),
            product_id: this.attr(null),
            row_num: this.attr(null),
            column_num: this.attr(null),
            image: this.attr(null),
            image_url: this.attr(null),
            image_fit: this.attr(0),
            image_halign: this.attr('center'),
            image_stretch: this.attr(1),
            image_valign: this.attr('center'),
            text: this.attr(''),
            text_halign: this.attr('center'),
            text_size: this.attr('12px'),
            text_valign: this.attr('center'),
            version: this.attr(1),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            category: this.attr(undefined, value => value ? new ProductCategory(value) : undefined),
            product: this.attr(undefined, value => value ? new Product(value) : undefined),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getProduct() {
        return Product.find(this.product_id);
    }
    getProductCategory() {
        return ProductCategory.find(this.category_id);
    }
    isProductButton() {
        return !!this.product_id;
    }
    isProductCategoryButton() {
        return !this.product_id && !!this.category_id;
    }
    isGroupButton() {
        return !this.product_id && !!this.group_id;
    }
}
export default Button;
modelRegistry.register('Button', Button);
//# sourceMappingURL=Button.js.map